import { useState } from "react"
import { Button, Form } from "react-bootstrap"
import { toast } from "react-toastify"

interface StartFlowProps {
  onSubmit: (email: string) => Promise<void>
  disabled?: boolean
}

export const StartFlow = ({ onSubmit, disabled }: StartFlowProps) => {
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState("")
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    try {
      await onSubmit(email)
    } catch (e) {
      console.error(e)
      toast.error("Unexpected error")
    } finally {
      setLoading(false)
    }
  }

  return <div>
    <Form onSubmit={handleSubmit} className="d-flex flex-column gap-2">
      <Form.Control type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} autoFocus autoComplete="email webauthn" />
      {loading ? <Button variant="success" type="submit" disabled>Signing in...</Button> : <Button variant="success" type="submit" disabled={!!disabled}>Sign in</Button>}
    </Form>
  </div>
}
